<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="outlined" class="warn-button" mat-dialog-close>{{ data.cancelText }}</button>
  <button matButton="filled" (click)="onConfirm()">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
